import {DiagnosticReport} from '@/practitioner/interfaces/DiagnosticReport';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const DIAGNOSTIC_REPORT_PATCHED_EVENT = 'diagnosticReport.patched';

export interface DiagnosticReportPatchedEvent extends DomainEvent {
  diagnosticReport: DiagnosticReport;
}

export function createDiagnosticReportPatchedEvent(
  diagnosticReport: DiagnosticReport
): DiagnosticReportPatchedEvent {
  return Object.freeze({
    name: DIAGNOSTIC_REPORT_PATCHED_EVENT,
    diagnosticReport
  });
}
